import LoginCard from '@/components/LoginCard.vue';
import AppAlert from '@/components/AppAlert';
import BigRadialBackground from "@/components/BigRadialBackground.vue";
import LogoWithDescription from "@/components/brand_elements/LogoWithDescription.vue";
export default {
  name: 'TheWrapperPublic',
  components: {
    LoginCard,
    AppAlert,
    BigRadialBackground,
    LogoWithDescription
  },
  props: {
    title: {
      type: String,
      default: null
    },
    scrollable: {
      type: Boolean,
      default: true
    }
  }
};